import { action, payload } from 'ts-action'
import { IInvoice, IInvoiceData } from '@network/models/invoice.model'
import { IError, IPayload } from '@network/models/global.model'
import { IInvoiceGroup } from '@network/models/invoice-group.model'
import { IProperty } from '@network/models/property.model'
import { ITimesheet } from '@network/models/timesheet.model'
import { IInvoiceExpenseType } from '@network/models/invoice-expense-type.model'
import { ICredit } from '@network/models/credit.model'

export const InvoiceFetching = action('InvoiceFetching', payload<boolean>())

export const GetInvoiceBatch = action(
  'GetInvoiceBatch',
  payload<IPayload<IInvoiceData>>(),
)

export const GetInvoice = action('GetInvoice', payload<IPayload<IInvoice>>())

export const GetInvoiceGroup = action(
  'GetInvoiceGroup',
  payload<IPayload<IInvoiceGroup>>(),
)

export const GetPropertiesForInvoice = action(
  'GetPropertiesForInvoice',
  payload<IPayload<IProperty[]>>(),
)

export const GetTimesheetsForInvoice = action(
  'GetTimesheetsForInvoice',
  payload<IPayload<ITimesheet[]>>(),
)

export const GetAdditionalExpenseTypesForInvoice = action(
  'GetAdditionalExpenseTypesForInvoice',
  payload<IPayload<IInvoiceExpenseType[]>>(),
)

export const GetCreditsForInvoice = action(
  'GetCreditsForInvoice',
  payload<IPayload<ICredit[]>>(),
)

export const GetInvoiceErrors = action('GetInvoiceErrors', payload<IError>())
